<template>
  <div :class="`col-md-${width} form-group`">
    <label v-if="label" class="control-label">
      {{ `${label} ${required ? '*' : ''}` }}
    </label>
    <p v-if="help" class="help-block">{{ help }}</p>

    <input
      ref="datepicker"
      type="text"
      autocomplete="off"
      class="form-control date-picker"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :value="value"
      @keydown.prevent
      @paste.prevent
      @input.prevent
      @drop.prevent
    />
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: String,
    help: String,
  },
  mounted() {
    const datepicker = this.$refs.datepicker;

    $(datepicker).on('apply.daterangepicker', (ev, picker) => {
      this.$emit('input', picker.startDate.format('DD/MM/YYYY'));
    });
  },
  watch: {
    value(newVal) {
      const datepicker = this.$refs.datepicker;
      if ($(datepicker).val() !== newVal) {
        $(datepicker).val(newVal);
      }
    },
  },
  beforeDestroy() {
    const datepicker = this.$refs.datepicker;
    $(datepicker).off('apply.daterangepicker');
  },
};
</script>

<style scoped>
.date-picker {
  background-color: #fff;
  cursor: pointer;
}
.date-picker:disabled {
  background-color: #eee;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/datePicker.vue